<template>
  <div class="flex justify-between">
    <div class="flex flex-none w-1/2">
      <router-link :to="{ name: 'Customer', params: { account: portal.subdomain } }" class="flex items-center hover:no-underline text-white px-3 py-0.5 text-sm truncate font-medium text-opacity-75 leading-none hover:text-opacity-100">
        &larr; Back to My Portal
      </router-link>
    </div>
    <div class="flex justify-end flex-none w-1/2">
      <div class="px-2.5 py-2 inline-flex text-white items-center text-sm leading-none max-w-full">
        <div class="hidden mr-1 text-white text-opacity-75 sm:block">
          Logged in as
        </div>
        <div class="font-bold truncate">
          {{ customer.name }}
        </div>
        <avatar 
          :username="customer.name" 
          :size="22" 
          color="rgb(var(--accent-color))" 
          background-color="#fff" 
          class="flex-none ml-2"
          :custom-style="{ 'font-weight': 'bold' }" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Avatar from 'vue-avatar'

export default {
  name: 'BookUserBar',

  components: {
    Avatar
  },

  computed: {
    ...mapState(['portal']),
    ...mapState('customer', ['customer']),
  }
}
</script>